









import {Component} from "vue-property-decorator"
import Vue from "vue"

import JdsSheet from "../../../design-system/patterns/Sheet/JdsSheet.vue"

@Component({
    components: {JdsSheet}
})
export default class SheetExampleInner extends Vue {
}
